import React, { useContext } from 'react'
import { ModalContext } from 'components/Modal'
import styled from 'styled-components'

const Container = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  > * {
    margin-bottom: 0;
  }
`

export default function storyblokTileProductTitle ({ data }) {
  const modal = useContext(ModalContext)
  const Title = modal != null ? 'h2' : 'h1'
  return (
    <Container>
      <div className="roofline">{data.roofline}</div>
      <Title>{data.title}</Title>
      <div className="subline">{data.subline}</div>
    </Container>
  )
}
